import { CustomeValidation } from './../../../shared/helpers/custome-validation';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../auth/services/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Credentials } from '../../../auth/models/credentials';
import { AccountTypes } from '../../../shared/models/AccountTypes';
import { AUthErrorMessages } from '../../../shared/constants/auth-constants';
import { AuthErrorCodes } from 'firebase/auth';

@Component({
  selector: 'app-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  styleUrls: ['./sign-in-form.component.scss']
})
export class SignInFormComponent implements OnInit {

  signInTypeErrorMsg = "Please select above signin as Candidate or Job Poster.";
  returnUrl: string;
  signInType: string = "";
  signInTypeStyles: string[] = [];
  failedAuthentication: boolean = false;
  errorMessage: string;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenticationService: AuthenticationService) {
    this.authenticationService.clearAuthenticationToken();
    this.signInTypeStyles[0] = "";
    this.signInTypeStyles[1] = "";
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"];
    this.form = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      signInType: [this.signInType, Validators.required],
    });
  }

  signInTypeClicked(signInType: string): void {
    this.signInType = signInType;
    this.errorMessage = "";
    this.form.patchValue({"signInType": signInType});
    switch (this.signInType) {
      case "employer": {
        this.signInTypeStyles[0] = "";
        this.signInTypeStyles[1] = "active";
        break;
      }
      case "candidate": {
        this.signInTypeStyles[1] = "";
        this.signInTypeStyles[0] = "active";
        break;
      }
    }
  }

  signIn(): void {
    if(!this.signInType) {
      this.errorMessage = this.signInTypeErrorMsg;
      return;
    }

    if(!this.form.valid) {
      return;
    }

    const credentials = new Credentials();
    credentials.username = this.form.value.username;
    credentials.password = this.form.value.password;
    credentials.accountType = this.signInType === "employer" ? AccountTypes.Employer : AccountTypes.Candidate;

    this.authenticationService.fireSignIn(credentials).then(res => {
      if (this.returnUrl) {
        this.router.navigateByUrl(this.returnUrl);
        return;
      }

      this.redirectAfterLogin(this.signInType);
    }).catch(error => {
      this.errorMessage = CustomeValidation.validateServerErrorMessage(error);
    });
  }

  googleSignIn(): void {
    if(!this.signInType) {
      this.errorMessage = this.signInTypeErrorMsg;
      return;
    }
    const accountType = this.signInType === "employer" ? AccountTypes.Employer : AccountTypes.Candidate;
    this.authenticationService.gmailSignIn(accountType).then(s => this.redirectAfterLogin(this.signInType));
  }
  onDismissError(){
    this.errorMessage = "";
  }
  onSignupClicked(): void {
    if (!this.returnUrl) {
      this.router.navigate(["/signup"]);
      return;
    }

    this.router.navigate(["/signup"], { queryParams: { returnUrl: this.returnUrl } });
  }

  private redirectAfterLogin(signInType: string): void {
    switch (this.signInType) {
      case "employer": {
        this.router.navigate(['/employer']);
        break;
      }
      case "candidate": {
        this.router.navigate(['/candidate']);
        break;
      }
    }
  }

}
